import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();
  const whyItems = t("why.items", { returnObjects: true }) as unknown as string[];

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              {t("about.title")}
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              {t("about.body")}
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              {t("about.body2")}
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <h3 className="font-heading text-xl font-semibold text-foreground-950">
              {t("why.title")}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              {t("why.subtitle")}
            </p>
            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {whyItems.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  <span className="text-sm text-foreground-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}